import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
/**
 * Merges Tailwind classes with clsx and tailwind-merge (shadcn-style utility).
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
